import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar, {
            app: "",
            color: "#121212",
            flat: ""
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_v_app_bar_nav_icon, {
                variant: "text",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.drawer = !_ctx.drawer), ["stop"]))
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_app_bar_title, { class: "font-weight-bold" }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("Mario Novak", -1)
                ])),
                _: 1,
                __: [2]
              }),
              _cache[3] || (_cache[3] = _createElementVNode("a", {
                href: "https://www.buymeacoffee.com/moltouni",
                target: "_blank",
                class: "mr-4 mt-2"
              }, [
                _createElementVNode("img", {
                  src: "https://cdn.buymeacoffee.com/buttons/v2/lato-white.png",
                  alt: "Buy Me A Coffee",
                  style: {"max-height":"42px !important"}
                })
              ], -1))
            ]),
            _: 1,
            __: [3]
          }),
          _createVNode(_component_v_navigation_drawer, {
            modelValue: _ctx.drawer,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.drawer) = $event)),
            location: _ctx.$vuetify.display.mobile ? 'bottom' : undefined,
            color: _ctx.$vuetify.display.mobile ? 'black' : 'rgba(0,0,0,0)',
            style: {"border":"none !important","box-shadow":"none !important","z-index":"999999"},
            temporary: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: item.title,
                  link: "",
                  href: item.value,
                  title: item.title
                }, null, 8, ["href", "title"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "location", "color"]),
          _createVNode(_component_router_view)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}